import get from "lodash.get";
import moment from "moment";
import { REHYDRATE } from "redux-persist";

import AuthenticationActionTypes from "services/authentication/types";
import ContractActionTypes from "services/contract/types";
import VisitorCharacteristicsActionTypes from "./types";

const VisitorCharacteristicsReducer = (state, action) => {
  const initialState = {
    autoRefresh: false,
    filters: {
      areas: [],
      selectedArea: undefined,
      from: parseInt(
        moment().subtract(1, "days").subtract(1, "months").startOf("day").unix()
      ),
      to: parseInt(moment().subtract(1, "days").endOf("day").unix()),
    },
    qualificationIndicators: {
      initialized: false,
      filters: {
        dow: [1, 2, 3, 4, 5, 6, 7],
      },
    },
    qualificationVisitors: {
      initialized: false,
      filters: {
        dow: [1, 2, 3, 4, 5, 6, 7],
      },
    },
    qualificationTime: {
      initialized: false,
      filters: {
        dow: [1, 2, 3, 4, 5, 6, 7],
      },
    },
    qualificationDestination: {
      initialized: false,
      filters: {
        dow: [1, 2, 3, 4, 5, 6, 7],
      },
    },
    catchmentAreas: {
      initialized: false,
      filters: {},
    },
  };

  if (!state) {
    state = initialState;
  }

  switch (action.type) {
    case REHYDRATE:
      return {
        ...initialState,
      };
    case ContractActionTypes.SWITCH_CONTRACT:
    case AuthenticationActionTypes.LOG_OUT:
      return initialState;
    case VisitorCharacteristicsActionTypes.SET_LOADING:
      return {
        ...state,
        [action.statName]: {
          ...state[action.statName],
          initialized: false,
        },
      };
    case VisitorCharacteristicsActionTypes.SET_AUTO_REFRESH:
      return {
        ...state,
        autoRefresh: action.autoRefresh,
      };
    case VisitorCharacteristicsActionTypes.SET_FILTERS:
      return {
        ...state,
        filters: action.data,
      };
    case VisitorCharacteristicsActionTypes.SET_FILTER:
      return {
        ...state,
        filters: {
          ...state.filters,
          [action.key]: action.value,
        },
      };
    case VisitorCharacteristicsActionTypes.SET_QUALIFICATION_INDICATORS_FILTERS:
      return {
        ...state,
        qualificationIndicators: {
          ...state.qualificationIndicators,
          filters: {
            ...state.qualificationIndicators.filters,
            ...get(action, "data", {}),
          },
          initialized: true,
        },
      };
    case VisitorCharacteristicsActionTypes.SET_QUALIFICATION_INDICATORS:
      return {
        ...state,
        qualificationIndicators: {
          ...state.qualificationIndicators,
          ...action.data,
          filters: {
            ...state.qualificationIndicators.filters,
            ...get(action, "data.filters", {}),
          },
          initialized: true,
        },
      };
    case VisitorCharacteristicsActionTypes.SET_QUALIFICATION_VISITORS_FILTERS:
      return {
        ...state,
        qualificationVisitors: {
          ...state.qualificationVisitors,
          filters: {
            ...state.qualificationVisitors.filters,
            ...get(action, "data", {}),
          },
          initialized: true,
        },
      };
    case VisitorCharacteristicsActionTypes.SET_QUALIFICATION_VISITORS:
      return {
        ...state,
        qualificationVisitors: {
          ...state.qualificationVisitors,
          ...action.data,
          filters: {
            ...state.qualificationVisitors.filters,
            ...get(action, "data.filters", {}),
          },
          initialized: true,
        },
      };
    case VisitorCharacteristicsActionTypes.SET_QUALIFICATION_TIME_FILTERS:
      return {
        ...state,
        qualificationTime: {
          ...state.qualificationTime,
          filters: {
            ...state.qualificationTime.filters,
            ...get(action, "data", {}),
          },
          initialized: true,
        },
      };
    case VisitorCharacteristicsActionTypes.SET_QUALIFICATION_TIME:
      return {
        ...state,
        qualificationTime: {
          ...state.qualificationTime,
          ...action.data,
          filters: {
            ...state.qualificationTime.filters,
            ...get(action, "data.filters", {}),
          },
          initialized: true,
        },
      };
    case VisitorCharacteristicsActionTypes.SET_QUALIFICATION_DESTINATION_FILTERS:
      return {
        ...state,
        qualificationDestination: {
          ...state.qualificationDestination,
          filters: {
            ...state.qualificationDestination.filters,
            ...get(action, "data", {}),
          },
          initialized: true,
        },
      };
    case VisitorCharacteristicsActionTypes.SET_QUALIFICATION_DESTINATION:
      return {
        ...state,
        qualificationDestination: {
          ...state.qualificationDestination,
          ...action.data,
          filters: {
            ...state.qualificationDestination.filters,
            ...get(action, "data.filters", {}),
          },
          initialized: true,
        },
      };
    case VisitorCharacteristicsActionTypes.SET_QUALIFICATION_CATCHMENT_AREAS_FILTERS:
      return {
        ...state,
        catchmentAreas: {
          ...state.catchmentAreas,
          filters: {
            ...state.catchmentAreas.filters,
            ...get(action, "data", {}),
          },
          initialized: true,
        },
      };
    case VisitorCharacteristicsActionTypes.SET_QUALIFICATION_CATCHMENT_AREAS:
      return {
        ...state,
        catchmentAreas: {
          ...state.catchmentAreas,
          ...action.data,
          filters: {
            ...state.catchmentAreas.filters,
            ...get(action, "data.filters", {}),
          },
          initialized: true,
        },
      };
    case VisitorCharacteristicsActionTypes.SET_INITIALIZED:
      return {
        ...state,
        initialized: action.value,
      };
    default:
      return state;
  }
};

export default VisitorCharacteristicsReducer;
